<template>
  <b-container class="mt-5">
    <b-card>
      <div class="text-center">
        <img src="@/assets/images/no-data.svg" alt="no Data" />
        <div class="mt-5">
          <p>صفحه درخواستی یافت نشد!</p>
          <p>
            از طریق دکمه زیر به صفحه اصلی منتقل شوید، سپس می‌توانید از لینک‌های
            موجود در سایت به صفحه مورد نظر خود هدایت شوید.
          </p>
          <b-button variant="primary" pill to="/">
            صفحه اصلی
          </b-button>
        </div>
      </div>
    </b-card>
  </b-container>
</template>

<script>
export default {
  name: "NotFound"
};
</script>

<style></style>
